<template>
    <v-progress-linear
        v-bind:indeterminate="true"
        v-bind:active="loading"
        color="accent"
        absolute
        bottom
    ></v-progress-linear>
</template>

<script>
export default {
  computed: {
    loading () {
      return this.$store.state.app.loading
    }
  }
}
</script>
